"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseClompString;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var SPACES = 2;
/** Selects the spaces at the beginning (for counting) and the identifier
 * afterwards. */

var lineRegex = /^([ ]*)([\w-:_@=()]+)[ ]*$/;

function repeat(numRepeat, callback) {
  if (numRepeat > 0) {
    callback();
    repeat(numRepeat - 1, callback);
  }
}

function getLineData(line) {
  var match = line.match(lineRegex);
  return (match === null || match === void 0 ? void 0 : match[2]) ? {
    identifier: match[2],
    indentions: match[1].length
  } : undefined;
}

function parseClompString(props, clompTemplates) {
  if (!clompTemplates) return "";
  var prevIndentions = undefined;
  var prevIdentifier = undefined;
  var groupContext = [];
  var classList = [];

  for (var _len = arguments.length, fns = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    fns[_key - 2] = arguments[_key];
  }

  var parsedStrings = fns.map(function (fn) {
    var _fn;

    return parseClompString(props, [(_fn = fn(props)) !== null && _fn !== void 0 ? _fn : ""]);
  });

  _toConsumableArray(clompTemplates).map(function (template) {
    template && template.split("\n").forEach(function (line, idx) {
      var lineData = getLineData(line);
      if (!lineData) return;
      var identifier = lineData.identifier,
          indentions = lineData.indentions;

      if (prevIndentions && indentions === prevIndentions + SPACES) {
        classList.pop();
        groupContext.push(prevIdentifier);
      } else if (prevIndentions && Number.isInteger((prevIndentions - indentions) / 2)) {
        var numPops = (prevIndentions - indentions) / 2;
        repeat(numPops, function () {
          var returned = groupContext.pop();
          if (!returned) throw new Error("Malformed Clomp on line ".concat(idx + 1, ":\n> \"").concat(line, "\"\nThis happened because the indention on this line is lesser than the initial indention."));
        });
      } else if (prevIndentions && prevIndentions > indentions) {
        // The current line has an unrecognized number of indentions.
        throw new Error("Malformed Clomp on line ".concat(idx + 1, ":\n> \"").concat(line, "\"\nThis happened because the indention on this line wasn't a multiple of ").concat(SPACES, " less than the one before it. If you would like to be able to change this number, make a feature request on GitHub or upvote an existing one that addresses this."));
      } else if (prevIndentions && prevIndentions < indentions) {
        throw new Error("Malformed Clomp on line ".concat(idx + 1, ":\n> \"").concat(line, "\"\nThis happened because the indention on this line wasn't ").concat(SPACES, " spaces more than the one before it. If you would like to be able to change this number, make a feature request on GitHub or upvote an existing one that addresses this."));
      }

      classList.push("".concat(groupContext.join("")).concat(identifier));
      prevIdentifier = identifier;
      prevIndentions = indentions;
    });
  });

  return [].concat(classList, _toConsumableArray(parsedStrings)).join(" ");
}